import React from "react";
import "./imgPrev.scss";
import { toast } from "react-toastify";

function ImgPreview({
  image,
  setImgPreview,
  facility_id,
  fetchFacilityDetails,
  setImage,
  uploadBtn,
  setUploadBtn,
}) {
  const closePreview = () => {
    setImgPreview(false);
    setImage(null);
    setUploadBtn(false);
  };

  const handleUploadImage = async () => {
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/membership/update_sports_facility_logo?facility_id=${facility_id}`;
    const accessToken = window.localStorage.getItem("access_token");
    const formData = new FormData();
    formData.append("facility_image", image);

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        toast.success("Facility logo updated successfully");
        setImgPreview(false);
        setImage(null);
        setUploadBtn(false);
        fetchFacilityDetails();
      } else if (response.status === 403) {
        toast.error(data.detail || "Permission denied");
        setImgPreview(false);
      } else if (response.status === 422) {
        toast.error(data.detail[0]?.msg || "Invalid input");
        setImgPreview(false);
      } else {
        toast.error(data.detail || "Failed to update logo");
        setImgPreview(false);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to update facility logo");
      setImgPreview(false);
    }
  };

  return (
    <>
      <div className="imgPrev">
        <p className="closeBtn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fefbfb"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-x"
            onClick={closePreview}
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </p>
        <div className="viewedImg">
          <img src={URL.createObjectURL(image)} alt="" />
        </div>
        <div className="uploadLog">
          <div className="delInvBtn">
            <div className="updateBtn" onClick={handleUploadImage}>
              <button>Upload</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ImgPreview;
